import apiClient from "./apiClient";

// ✅ Fetch all services/products
export const fetchServicesAPI = () => {
  return apiClient.get("/tailmission/api/v1/products");
};

// ✅ Create a new service/product
export const createServiceAPI = (serviceData) => {
  return apiClient.post("/tailmission/api/v1/products", { product: serviceData });
};

// ✅ Update a service/product by ID
export const updateServiceAPI = (id, serviceData) => {
  // Check if data contains FormData (for image uploads)
  const isFormData = serviceData instanceof FormData;

  const config = {
    headers: {
      ...(isFormData ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'application/json' })
    }
  };

  return apiClient.put(`/tailmission/api/v1/products/${id}`, isFormData ? serviceData : { product: serviceData }, config);
};

// ✅ Delete a service/product by ID
export const deleteServiceAPI = (id) => {
  return apiClient.delete(`/tailmission/api/v1/products/${id}`);
};

// ✅ Fetch a single service/product by ID
export const fetchServiceByIdAPI = (id) => {
  return apiClient.get(`/tailmission/api/v1/products/${id}`);
};
